import React from "react";
import newLogo from "../../assets/newLogo.png"; 
import "./style.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="brand-logo">
              <img src={newLogo} alt="Big Cat Graphics" className="logo-img" />
              <a href="/"><span className="brand-name">BIG CAT GRAPHICS</span></a>
            </div>
            <p className="brand-description">
              Bringing your creative ideas to life with cutting-edge 3D design, CGI, and graphic design solutions.
            </p>
          </div>

          {/* Services */}
          <div className="footer-services">
            <h3>Services</h3>
            <ul>
              <li>3D Design</li>
              <li>CGI</li>
              <li>Graphic Design</li>
              <li>Photography</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact">
            <h3>Contact</h3>
            <ul>
              <li><a href="mailto:info@bigcatgraphics.co.za">info@bigcatgraphics.co.za</a></li>
              <li><a href="tel:+27719142461">+27 71 914 2461</a></li>
              <li>Johannesburg</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Big Cat Graphics. All rights reserved.</p>
          <div className="footer-links">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
            <a href="/cookies">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
